import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Accordion } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import { AiOutlineStar, AiTwotoneStar } from "react-icons/ai";
import { Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Swal from "sweetalert2";
import parse from "html-react-parser";
import { Spinner } from "react-bootstrap";

import api from "../../_services/api";
import {
  clientesApi,
  pedidosApi,
  produtosApi,
} from "../OrderResumePag/_services/api";
import { useApp } from "../../contexts/AppContext";
import { useUserData } from "../../hooks/UserContext";
import notify from "../../components/UI/toast";

import PriceDetailProduct from "../../components/PriceDetailProduct";
import ImageBreak from "../../assets/image-break.png";
import {
  Banner,
  Content,
  CashbackInfo,
  StarIcon,
  Description,
  SoldBy,
  Title,
  Brand,
  VariationGrid,
  VariationSelect,
  VariationLabel,
  AccordionWrapper,
  ProductDivider,
  FixedFooter,
  ProductLayout,
} from "./styles";
import ShippingEstimate from "../../components/ShippingEstimate";
import ModalApp from "../../components/ModalApp";
import AddressComponent from "../../components/AddressComponent";
import {
  editAddresses,
  addAddress,
} from "../../components/AddressComponent/services/addressService";
import {
  trackViewItemMarketplace,
  trackMarketplaceAddToCart,
} from "../../utils/gtm";
import { useDispatch } from "react-redux";
import { getCart } from "../../Redux/cartSlice";

import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import { useFeatureFlag } from "../../contexts/FeatureFlagProvider";

const CART_WARNING = {
  INVALID_QUANTITY: "invalid_quantity",
  INSUFFICIENT_STOCK: "insufficient_stock",
};

const CART_WARNING_MESSAGES = {
  [CART_WARNING.INVALID_QUANTITY]:
    "A quantidade informada não está disponível para este produto.",
  [CART_WARNING.INSUFFICIENT_STOCK]:
    "Produto sem estoque.",
};

const PDP_PRODUCT_TITLE_LIMIT = 100;

const formatTitle = (val) => {
  const title = val ? String(val).toLocaleLowerCase() : "";
  let result = "";
  switch (title) {
    case "size":
      result = "Tamanho";
      break;
    case "color":
      result = "Cor";
      break;
    case "voltage":
      result = "Voltagem";
      break;

    default:
      break;
  }
  return result;
};

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-default-wl",
    cancelButton: "btn btn-cancel-wl",
  },
  buttonsStyling: false,
  reverseButtons: true,
});

export default function ProductItem() {
  const { whitelabel } = useApp();
  const configData = whitelabel?.config || {};
  const channel = process.env.REACT_APP_DEFAULT_CHANNEL;
  const fatorFreteKey = `fator_${channel}_frete`;
  const fatorFrete = configData[fatorFreteKey] / 10000 || 0;

  const jwt = useUserData();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const {
    user,
    addressShipping,
    addressesData,
    setUpdateAddresses,
    changeAddress,
  } = useUserData();
  const [data, setData] = useState([]);
  const [dataUser, setDataUser] = useState();
  const [enterJWT, setEnterJWT] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [variations, setVariations] = useState([]);
  const [wishlist, setWishList] = useState(false);
  const [displayMode, setDisplayMode] = useState(
    whitelabel?.config?.payment_mode,
  );
  const [selectedVariations, setSelectedVariations] = useState({});
  const [cartAdded, setCartAdded] = useState(false);
  const [shippingError, setShippingError] = useState(false);
  const [shippingState, setShippingState] = useState("loading");
  const [isBuying, setIsBuying] = useState(false);
  const [addressModalOpen, setAddressModalOpen] = useState(false);
  const [addressDraft, setAddressDraft] = useState({});
  const viewItemSentFor = useRef(null);
  const titleRef = useRef(null);
  const [isTitleExpanded, setIsTitleExpanded] = useState(false);
  const [titleMaxHeight, setTitleMaxHeight] = useState("none");
  const favoritesEnabled = useFeatureFlag("favorites");
  const productTitle = typeof data?.label === "string" ? data.label : "";
  const isTitleTruncated = productTitle.length > PDP_PRODUCT_TITLE_LIMIT;
  const displayedTitle =
    isTitleExpanded || !isTitleTruncated
      ? productTitle
      : `${productTitle.slice(0, PDP_PRODUCT_TITLE_LIMIT)}...`;

  useEffect(() => {
    setIsTitleExpanded(false);
    setTitleMaxHeight("none");
  }, [id]);

  useLayoutEffect(() => {
    if (!isTitleExpanded || !titleRef.current) return undefined;

    const expandedHeight = titleRef.current.scrollHeight;
    const animationFrame = window.requestAnimationFrame(() => {
      setTitleMaxHeight(`${expandedHeight}px`);
    });

    return () => window.cancelAnimationFrame(animationFrame);
  }, [displayedTitle, isTitleExpanded]);

  const handleTitleExpand = () => {
    if (!isTitleTruncated || isTitleExpanded) return;

    const collapsedHeight = titleRef.current?.clientHeight;
    if (collapsedHeight) setTitleMaxHeight(`${collapsedHeight}px`);
    setIsTitleExpanded(true);
  };

  const handleTitleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleTitleExpand();
    }
  };

  const handleTitleTransitionEnd = (event) => {
    if (event.propertyName === "max-height" && isTitleExpanded) {
      setTitleMaxHeight("none");
    }
  };

  const isMainAddr = (addr) =>
    addr?.main === true || addr?.main === 1 || addr?.main === "1";
  const findMainAddr = (list) => list?.find(isMainAddr) || list?.[0];
  const mainAddress = findMainAddr(addressesData);

  // `addressShipping` is treated as the source of truth when non-empty.
  // This matches the logic used in OrderResume so both screens show the
  // same default address.
  const hasActiveShipping =
    addressShipping &&
    !Array.isArray(addressShipping) &&
    Object.keys(addressShipping).length > 0;

  const rawDeliveryAddress = hasActiveShipping ? addressShipping : mainAddress;

  // Normalise legacy field shapes (address_line1/2/3 + cep) into the
  // canonical shape (streetName/neighborhood/complement + zipCode)
  // so ShippingEstimate renders the address consistently.
  const normalizeAddress = (addr) =>
    addr
      ? {
          ...addr,
          streetName: addr.streetName || addr.address_line1 || "",
          neighborhood: addr.neighborhood || addr.address_line2 || "",
          complement: addr.complement || addr.address_line3 || "",
          zipCode: addr.zipCode || addr.cep || "",
        }
      : null;

  const effectiveDeliveryAddress = normalizeAddress(rawDeliveryAddress);

  const mainCep = effectiveDeliveryAddress?.zipCode;

  const screenName = useScreenTracking();
  const isDesktop = useMediaQuery("(min-width:1024px)");
  const trackClickBuyEvent = ({ title }) => {
    trackClick({
      title,
      contentType: "select_content",
      screenName,
      tagId: tagIdFromLegacySuffix("14"),
    });
  };

  useEffect(() => {
    setShippingState("loading");
    setIsBuying(false);
  }, [id]);

  useEffect(() => {
    setDisplayMode(whitelabel?.config?.payment_mode);
  }, [whitelabel]);

  useEffect(() => {
    if (jwt.userData?.data && !enterJWT) {
      setEnterJWT(true);
      setDataUser(jwt.userData.data);
    }
    // eslint-disable-next-line
  }, [jwt.userData, enterJWT]);

  async function addCart(productSku) {
    try {
      const res = await pedidosApi.post(`v2/carrinho/${channel}`, {
        customerUuid: user.uuid,
        cep:
          addressShipping?.cep ||
          (user?.addresses?.length ? user.addresses[0].cep : "") ||
          "05424000",
        sku: productSku,
        quantity: 1,
        fator: fatorFrete,
      });

      const warnings = Object.values(res.data.data.warnings).flat();

      trackClickBuyEvent({ title: "comprar" });

      if (warnings.some((warning) => warning.error)) {
        const warningCode = warnings[0].message;
        notify(CART_WARNING_MESSAGES[warningCode] ?? warningCode, "error");
        return;
      }

      trackMarketplaceAddToCart({
        itemId: data.uuid || id,
        itemName: data.label,
        discount:
          data.price?.BRL?.price && data.price?.BRL?.offer
            ? Math.max(
                0,
                parseFloat(data.price.BRL.price) -
                  parseFloat(data.price.BRL.offer),
              )
            : 0,
        index: 0,
        itemBrand: data.brand?.name || "",
        itemCategory: data.categories?.[0]?.name || data.category_name || "",
        price: parseFloat(data.price?.BRL?.offer || 0),
        quantity: 1,
      });

      const uuid = user.uuid;
      const cep =
        addressShipping?.cep ||
        (user?.addresses?.length ? user.addresses[0].cep : undefined);
      await dispatch(getCart({ uuid, cep, force: true })).unwrap();
      navigate("/loja/orderresume");
      return true;
    } catch (err) {
      notify(err.response?.data?.message || "Erro ao adicionar ao carrinho", "error");
      return false;
    }
  }

  async function handleBuy() {
    setIsBuying(true);

    try {
      if (cartAdded) {
        trackClickBuyEvent({ title: "comprar" });
        const uuid = user.uuid;
        const cepValue =
          addressShipping?.cep ||
          (user?.addresses?.length ? user.addresses[0].cep : undefined);
        await dispatch(getCart({ uuid, cep: cepValue, force: true })).unwrap();
        navigate("/loja/orderresume");
      } else {
        const success = await addCart(data.sku);
        if (!success) {
          setIsBuying(false);
        }
      }
    } catch {
      setIsBuying(false);
    }
  }

  function handleChangeVariation(value, type) {
    const updatedSelections = { ...selectedVariations, [type]: value };
    setSelectedVariations(updatedSelections);

    const variationKeys = Object.keys(data.variations);
    const variationsList = Object.values(data.variations);

    const matchingVariation = variationKeys.find((uuid, idx) => {
      const variation = variationsList[idx];
      return Object.entries(updatedSelections).every(
        ([k, v]) => variation[k]?.value === v,
      );
    });

    if (matchingVariation) {
      navigate(`/loja/product/${matchingVariation}`);
    }
  }

  async function products(id) {
    const response = await produtosApi.get("/v1/produto/" + id);
    return response.data.data;
  }

  async function apiWishlist() {
    if (!dataUser?.cpf) {
      console.warn(
        "CPF não encontrado no dataUser, retornando array vazio para wishlist",
      );
      return [];
    }

    try {
      const response = await clientesApi.get(
        `/customer/wishlist`,
      );
      return response.data.data;
    } catch (error) {
      console.error("Erro ao buscar wishlist:", error);
      return [];
    }
  }

  async function onClickStar() {
    if (!user?.cpf) {
      notify("Entre na sua conta para favoritar produtos", "warning");
      return;
    }
    const nextState = !wishlist;
    setWishList(nextState);
    try {
      if (nextState) {
        await clientesApi.post("/customer/wishlist", {
          product_uuid: id,
          customer_uuid: user?.uuid,
        });
        notify("Produto adicionado aos favoritos", "success");
      } else {
        await clientesApi.delete(
          "/customer/wishlist/product/" + id,
        );
        notify("Produto removido dos favoritos", "success");
      }
    } catch (e) {
      setWishList(!nextState);
      notify(
        e?.response?.data?.message || "Erro ao atualizar favoritos",
        "error",
      );
    }
  }

  const onImageError = (e) => {
    e.target.src = ImageBreak;
  };

  async function productCtr(id) {
    try {
      await produtosApi.post("/v1/products/productCtr?product_uuid=" + id);
    } catch (error) {
      console.warn("Falha ao registrar visualização do produto:", error);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(() => true);

      try {
        const wishlistData = await apiWishlist();
        const response = await products(id);
        setData(response);
        setWishList(wishlistData.some((item) => item.product_uuid === id));

        productCtr(id);

        if (viewItemSentFor.current !== id) {
          trackViewItemMarketplace({
            itemId: response.uuid || id,
            itemName: response.label,
            discount:
              response.price?.BRL?.price && response.price?.BRL?.offer
                ? Math.max(
                    0,
                    parseFloat(response.price.BRL.price) -
                      parseFloat(response.price.BRL.offer),
                  )
                : 0,
            index: 0,
            itemBrand: response.brand?.name || "",
            itemCategory:
              response.categories?.[0]?.name || response.category_name || "",
            price: parseFloat(response.price?.BRL?.offer || 0),
            quantity: 1,
          });
          viewItemSentFor.current = id;
        }

        setImages(response.images);
        if (response.variations) {
          setVariations(response.variations);
        }
        setLoading(false);
      } catch (error) {
        notify("Erro ao tentar carregar item", "error");
      }
    };

    if (user && user.cpf && id) fetchData();
  }, [user, id, dataUser]);

  useEffect(() => {
    if (data.variations && id) {
      const currentVariation = data.variations[id];
      if (currentVariation) {
        const currentSelections = {};
        Object.entries(currentVariation).forEach(([key, variation]) => {
          if (variation && variation.value) {
            currentSelections[key] = variation.value;
          }
        });
        setSelectedVariations(currentSelections);
      }
    }
  }, [id, data.variations]);

  const [shippingBtnLoader, setShippingBtnLoader] = useState(false)
  const [shippingCalculated, setShippingCalculated] = useState(false);
  const buyDisabled =
    parseInt(data.stock) === 0 ||
    shippingError ||
    !shippingCalculated ||
    shippingBtnLoader;

  const buyButton = (
    <Button
      onClick={() => {
        setShippingBtnLoader(true);
        handleBuy();
      }}
      className="btn-default-wl text-xxs p-3 w-100"
      style={{ borderRadius: "10px" }}
      disabled={buyDisabled}
    >
      {shippingBtnLoader ? (
        <>
          <Spinner animation="border" size="sm" className="me-2" />
          AGUARDE ...
        </>
      ) : (
        "COMPRAR"
      )}
    </Button>
  );

  return (
    !Loading && (
      <div className="wl-page">
        <ProductLayout>
          <div className="pdp-gallery">
            <Banner>
              {favoritesEnabled && (
                <StarIcon
                  onClick={onClickStar}
                  role="button"
                  aria-label="Favoritar"
                >
                  {wishlist ? (
                    <AiTwotoneStar
                      size={20}
                      color={whitelabel?.theme?.button_primary_color}
                    />
                  ) : (
                    <AiOutlineStar
                      size={20}
                      color={whitelabel?.theme?.button_primary_color}
                    />
                  )}
                </StarIcon>
              )}
              <Carousel className="carousel-wl" variant="dark">
                {images.map((item, index) => {
                  return (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100"
                        src={item.path}
                        alt=""
                        onError={onImageError}
                      />
                    </Carousel.Item>
                  );
                })}
              </Carousel>
            </Banner>
          </div>

          <div className="pdp-info">
            <Content>
              {data?.cashback && parseFloat(data.cashback) > 0 && (
                <CashbackInfo className="mb-4">
                  <Typography>{`Você vai ganhar ${parseFloat(
                    data?.cashback,
                  )}% de cashback`}</Typography>
                </CashbackInfo>
              )}

              {data?.stock && parseInt(data.stock) === 0 && (
                <p className="font-wl-700 text-xs color-text-warning mb-4">
                  PRODUTO SEM ESTOQUE
                </p>
              )}

              <SoldBy>
                Vendido por: <span>{data.seller_name}</span>
              </SoldBy>

              <Title
                ref={titleRef}
                $isExpandable={isTitleTruncated && !isTitleExpanded}
                $maxHeight={titleMaxHeight}
                onClick={handleTitleExpand}
                onKeyDown={handleTitleKeyDown}
                onTransitionEnd={handleTitleTransitionEnd}
                role={isTitleTruncated ? "button" : undefined}
                tabIndex={isTitleTruncated ? 0 : undefined}
              >
                {displayedTitle}
              </Title>

              <Brand>{data?.brand?.name}</Brand>
              <PriceDetailProduct
                price={data?.price}
                displayMode={displayMode}
              />

              {data.variations &&
                (() => {
                  const variationGroups = {};
                  Object.values(data.variations || {}).forEach(
                    (variationSet) => {
                      Object.entries(variationSet).forEach(
                        ([key, variation]) => {
                          if (!variationGroups[key])
                            variationGroups[key] = new Set();
                          variationGroups[key].add(variation.value);
                        },
                      );
                    },
                  );
                  const totalUniqueValues = Object.values(
                    variationGroups,
                  ).reduce((acc, set) => acc + set.size, 0);
                  if (
                    Object.keys(variationGroups).length === 1 &&
                    totalUniqueValues === 1
                  )
                    return null;

                  return (
                    <VariationGrid>
                      {Object.entries(variationGroups).map(([type, values]) => (
                        <div key={type}>
                          <VariationLabel>{formatTitle(type)}</VariationLabel>
                          <VariationSelect
                            value={selectedVariations[type] || ""}
                            onChange={(e) =>
                              handleChangeVariation(e.target.value, type)
                            }
                          >
                            {[...values].map((val) => (
                              <option key={val} value={val}>
                                {val}
                              </option>
                            ))}
                          </VariationSelect>
                        </div>
                      ))}
                    </VariationGrid>
                  );
                })()}

              <ShippingEstimate
                sku={data.sku}
                userCep={mainCep}
                userAddress={effectiveDeliveryAddress}
                userUuid={user?.uuid}
                onCartAdded={setCartAdded}
                onAddressChange={changeAddress}
                onError={setShippingError}
                displayMode={displayMode}
                onShippingCalculated={() => setShippingCalculated(true)}
              />

              {isDesktop && <div className="pdp-buy">{buyButton}</div>}
            </Content>
          </div>

          <div className="pdp-details">
            <ProductDivider />
            <AccordionWrapper>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Detalhes</Accordion.Header>
                  <Accordion.Body>
                    {data.descriptionHtml ? (
                      <div
                        className="font-wl-400 color-text-dark text-sm"
                        dangerouslySetInnerHTML={{
                          __html: data.descriptionHtml,
                        }}
                      />
                    ) : (
                      <Description className="font-wl-400 text-sm">
                        {parse(data.description)}
                      </Description>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </AccordionWrapper>
          </div>
        </ProductLayout>

        {!isDesktop && <FixedFooter>{buyButton}</FixedFooter>}

        <ModalApp
          show={addressModalOpen}
          handleModal={() => {
            setAddressModalOpen(false);
            setShippingCalculated(true);
            setShippingBtnLoader(false);
          }}
          desktopSize="medium"
        >
          <AddressComponent
            address={addressDraft}
            highlightMissingFields
            onCancel={() => {
              setAddressModalOpen(false);
              setShippingCalculated(true);
              setShippingBtnLoader(false);
            }}
            onConfirm={async (payload) => {
              try {
                const body = { ...payload, customerUuid: user.uuid };
                const normalizeCep = (v) => (v || "").replace(/\D/g, "");
                const isEditingMain =
                  addressDraft?.uuid &&
                  mainAddress?.uuid &&
                  addressDraft.uuid === mainAddress.uuid &&
                  normalizeCep(addressDraft.cep || addressDraft.zipCode) ===
                    normalizeCep(mainAddress.cep || mainAddress.zipCode);
                const resp = isEditingMain
                  ? await editAddresses(body)
                  : await addAddress(body);
                const savedFromApi = resp?.data?.data || {};
                const saved = {
                  ...addressDraft,
                  ...body,
                  ...savedFromApi,
                  uuid: savedFromApi.uuid || addressDraft?.uuid,
                };
                changeAddress(saved);
                setUpdateAddresses(new Date());
                setShippingCalculated(true);
                setShippingBtnLoader(false);
                setAddressModalOpen(false);
                notify("Endereço atualizado com sucesso", "success");
              } catch (err) {
                notify(
                  err?.response?.data?.message ||
                    "Erro ao atualizar endereço",
                  "error",
                );
                throw err;
              }
            }}
          />
        </ModalApp>
      </div>
    )
  );
}

ProductItem.propTypes = {
  product: PropTypes.object,
};
